import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'loaders-inline',
  templateUrl: './loaders-inline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loaders-inline.component.scss'
})
export class LoadersInlineComponent {
  @Input() type:number=0;
}
